import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { map, take } from 'rxjs/operators';

import { DynamicFeatureFlagService } from 'shared/services';

import { ADMIN_PLATFORM_FEATURE_FLAG } from '../constants/admin-routes.constants';

/** Loads `admin-platform-v2` when `enable_admin_platform` is on. */
export const adminPlatformV2CanMatchGuard: CanMatchFn = () =>
    inject(DynamicFeatureFlagService).isFeatureEnabled$(ADMIN_PLATFORM_FEATURE_FLAG).pipe(take(1));

/** Loads legacy `admin-platform` when `enable_admin_platform` is off. */
export const adminPlatformLegacyCanMatchGuard: CanMatchFn = () =>
    inject(DynamicFeatureFlagService)
        .isFeatureEnabled$(ADMIN_PLATFORM_FEATURE_FLAG)
        .pipe(
            take(1),
            map((enabled) => !enabled)
        );
